"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[536],{

/***/ 5759:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgReactIcon = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "175 52 490 490"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M666 297c0-33-40-64-103-83 15-64 8-114-20-130-7-4-14-6-22-6v22c4 0 8 1 11 3 14 8 19 37 15 76l-5 29c-20-5-41-8-64-11-13-18-27-35-41-50 32-30 63-47 84-47V78c-28 0-64 20-100 54-37-34-73-54-100-54v23c21 0 51 16 84 46-14 15-28 32-41 50-23 3-44 6-64 11l-5-29c-5-38 1-68 14-76l12-2V78v1c-9 0-16 1-23 5-28 16-34 67-20 130-62 19-102 50-102 82 0 33 40 64 103 83-15 63-8 114 20 130 6 4 14 6 22 6 28 0 64-20 100-54 37 34 73 53 100 53 9 1 16-1 23-5 28-16 34-67 20-130 62-19 102-50 102-82zm-130-67-13 39a473 473 0 0 0-28-47l41 8zm-46 106c-7 14-15 27-24 39a520 520 0 0 1-90 0 551 551 0 0 1-45-78 521 521 0 0 1 45-78 520 520 0 0 1 90 0 551 551 0 0 1 45 77c-6 14-13 27-21 40zm33-13c5 14 10 27 13 40l-41 8a552 552 0 0 0 28-48zM421 430l-28-32a619 619 0 0 0 56 0c-9 12-19 22-28 32zm-74-59-41-8 13-39a473 473 0 0 0 28 47zm74-208 27 32a619 619 0 0 0-55 0c9-12 19-22 28-32zm-74 59a552 552 0 0 0-28 48c-5-14-10-27-13-40l41-8zm-91 125c-35-15-58-35-58-50 0-16 23-36 58-51l28-10c6 19 13 40 22 61-9 20-16 41-22 60l-28-10zm54 143c-14-8-19-37-15-76l5-29c20 5 41 8 64 11 13 18 27 35 41 50-32 30-63 47-84 47-4 0-8-1-11-3zm237-76c5 38-1 68-14 76l-12 2c-21 0-51-16-84-46 14-15 28-32 41-50 23-3 44-6 64-11l5 29zm39-67-28 10c-6-19-13-40-22-61 9-20 16-41 22-60l28 10c35 15 58 35 58 51 0 15-23 35-58 50zM321 78z"
})), _circle || (_circle = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("circle", {
  cx: 420.9,
  cy: 296.5,
  r: 45.7
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgReactIcon);

/***/ }),

/***/ 6771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgDiscord = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 -2.5 21 21"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M17.66 1.45A16.94 16.94 0 0 0 13.453.147c-.023-.007-.05.004-.066.032-.18.32-.383.742-.524 1.07a15.948 15.948 0 0 0-4.722 0A11.433 11.433 0 0 0 7.609.18a.072.072 0 0 0-.07-.032A16.73 16.73 0 0 0 3.336 1.45a.06.06 0 0 0-.031.024C.629 5.465-.105 9.355.254 13.203c0 .02.012.035.027.047a17.056 17.056 0 0 0 5.16 2.602c.028.007.055 0 .07-.024.4-.543.755-1.113 1.06-1.71a.07.07 0 0 0-.04-.095 10.668 10.668 0 0 1-1.61-.765.064.064 0 0 1-.007-.11c.11-.082.215-.164.32-.25a.06.06 0 0 1 .067-.007c3.383 1.539 7.043 1.539 10.387 0 .019-.012.046-.008.066.007.101.086.21.168.32.25a.066.066 0 0 1-.004.11c-.515.3-1.05.555-1.613.765a.066.066 0 0 0-.035.094c.308.598.664 1.168 1.055 1.711.015.024.043.031.07.024a16.958 16.958 0 0 0 5.168-2.602c.015-.012.027-.027.027-.047.43-4.445-.722-8.308-3.054-11.73-.004-.012-.016-.02-.028-.024ZM7.074 10.86c-1.02 0-1.86-.93-1.86-2.075 0-1.148.825-2.078 1.86-2.078 1.043 0 1.871.941 1.856 2.078 0 1.145-.82 2.074-1.856 2.074Zm6.864 0c-1.016 0-1.856-.93-1.856-2.075 0-1.148.824-2.078 1.856-2.078 1.042 0 1.875.941 1.859 2.078 0 1.145-.817 2.074-1.86 2.074Zm0 0"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgDiscord);

/***/ }),

/***/ 3869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgFacebook = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M75 512h167V330h-60v-60h60v-75a75 75 0 0 1 75-75h75v60h-60a30 30 0 0 0-30 30v60h87.3l-10 60H302v182h135a75 75 0 0 0 75-75V75a75 75 0 0 0-75-75H75A75 75 0 0 0 0 75v362a75 75 0 0 0 75 75zM30 75a45 45 0 0 1 45-45h362a45 45 0 0 1 45 45v362a45 45 0 0 1-45 45H332V360h72.7l20-120H332v-30h90V90H317c-57.9 0-105 47.1-105 105v45h-60v120h60v122H75a45 45 0 0 1-45-45zm0 0"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgFacebook);

/***/ }),

/***/ 493:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgJs = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  stroke: "transparent",
  viewBox: "31.88 31.88 336.56 336.25"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M43.805 33.962c-5.273 2.487-7.676 4.934-10.102 10.286-1.795 3.958-1.806 4.89-1.817 155.752l-.01 151.77 2.086 4.425c2.487 5.273 4.934 7.676 10.286 10.102 3.958 1.795 4.89 1.806 155.752 1.817l151.77.01 4.425-2.086c5.273-2.487 7.676-4.934 10.102-10.286 2.848-6.281 2.848-305.223 0-311.504-2.426-5.352-4.829-7.799-10.102-10.286l-4.425-2.086H48.23l-4.425 2.086m306.132 16.101c2.128 2.128 2.128 297.746 0 299.874-2.128 2.128-297.746 2.128-299.874 0-2.128-2.128-2.128-297.746 0-299.874 2.128-2.128 297.746-2.128 299.874 0m-166.751 187.53c0 48.001-.168 54.827-1.428 57.976-4.655 11.633-22.652 10.322-32.604-2.375-1.968-2.512-3.818-4.596-4.11-4.633-1.828-.226-25.624 15.346-25.187 16.483 11.551 30.103 61.895 41.618 84.257 19.273 11.904-11.895 12.029-12.728 12.466-82.503l.367-58.628h-33.761v54.407m93.363-53.446c-23.287 2.504-37.737 18.062-37.72 40.611.017 22.999 9.118 33.741 40.375 47.656 20.218 9.001 25.141 13.634 24.119 22.698-2.182 19.365-30.933 17.334-44.053-3.111-1.55-2.415-2.985-4.39-3.191-4.39-.868 0-24.22 16.018-24.212 16.608.027 2.154 6.439 11.237 11.413 16.168 24.943 24.729 75.955 20.014 89.049-8.23 6.324-13.641 4.978-31.946-3.263-44.389-5.654-8.535-14.123-13.829-44.826-28.02-11.997-5.545-15.261-9.659-14.338-18.067 1.391-12.665 21.003-14.031 29.923-2.084 3.766 5.045 2.716 5.24 15.458-2.877 13.842-8.818 13.14-7.587 8.24-14.453-10.154-14.23-26.066-20.368-46.974-18.12"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgJs);

/***/ }),

/***/ 6505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgLinkedin = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M437 0H75A75 75 0 0 0 0 75v362a75 75 0 0 0 75 75h362a75 75 0 0 0 75-75V75a75 75 0 0 0-75-75zm45 437a45 45 0 0 1-45 45H75a45 45 0 0 1-45-45V75a45 45 0 0 1 45-45h362a45 45 0 0 1 45 45zm0 0"
})), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M91 422h90V210H91zm30-182h30v152h-30zm210-30a89.8 89.8 0 0 0-30 5.1V210h-90v212h90V315a15 15 0 0 1 30 0v107h90V304.7c0-48.6-39.4-94.7-90-94.7zm60 182h-30v-77a45 45 0 0 0-90 0v77h-30V240h30v30l24-18a59.5 59.5 0 0 1 36-12c32 0 60 30.3 60 64.7zM91 180h90V90H91zm30-60h30v30h-30zm0 0"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgLinkedin);

/***/ }),

/***/ 5452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgTs = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 128 128"
}, props), _rect || (_rect = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("rect", {
  width: 120,
  height: 120,
  x: 4,
  y: 4,
  stroke: "currentColor",
  strokeLinejoin: "round",
  strokeWidth: 7,
  rx: 5,
  ry: 5
})), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  fill: "currentColor",
  d: "M74.3 99.5v14c2.2 1.2 5 2 8 2.6a52.9 52.9 0 0 0 19.4 0c3-.7 5.6-1.8 8-3.2a16.2 16.2 0 0 0 7.3-14.7 15.6 15.6 0 0 0-4.4-11.8 24 24 0 0 0-5.1-4 55 55 0 0 0-6.8-3.3 84.8 84.8 0 0 1-8.7-4.4c-1-.8-1.8-1.6-2.3-2.4a5 5 0 0 1-.8-2.8c0-1 .2-1.8.7-2.6s1.2-1.5 2.1-2c.9-.6 2-1 3.3-1.3 1.3-.3 2.8-.5 4.4-.5a27.6 27.6 0 0 1 14.8 4.4v-13c-2-1-4.4-1.5-7-2a46.3 46.3 0 0 0-18 .6 24 24 0 0 0-7.9 3.3c-2.2 1.5-4 3.5-5.3 5.8a17 17 0 0 0-2 8.5c0 4.2 1.2 7.7 3.6 10.7 2.4 3 6 5.4 11 7.5l5.3 2.3c1.7.7 3.1 1.5 4.3 2.4s2.2 1.7 2.9 2.6a5.5 5.5 0 0 1 .4 5.8c-.4.8-1.1 1.5-2 2-.9.6-2 1-3.3 1.4a26.5 26.5 0 0 1-22-6zm-23.6-35H69V53H18v11.6h18.2V116h14.5z",
  clipRule: "evenodd"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgTs);

/***/ }),

/***/ 1071:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgTwitter = props => /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 -47 512 512"
}, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
  d: "M512 56c-32.2 1.4-31.5 1.3-35.1 1.6l19-54.4S436.4 25 421.3 29C381.7-6.6 322.7-8.2 280.6 17.7a97.4 97.4 0 0 0-46.8 100.2A259.9 259.9 0 0 1 65.4 23L51.3 6 40.7 25.5a117.1 117.1 0 0 0-12.4 78.8c2.1 10.9 5.8 21.2 11 30.8L27 130.4l-1.4 20.3A108 108 0 0 0 44 214.9c3.6 5.5 8.3 11.6 14.3 17.6l-6.3-1 7.6 23.2c10 30.5 31 54 58 67.2a984.8 984.8 0 0 1-84.8 30.6L0 363.3l30.3 16.6c11.6 6.3 52.5 27.4 92.9 33.8 89.7 14 190.8 2.6 258.8-58.7 57.3-51.6 76.1-125 72.2-201.4a47.7 47.7 0 0 1 9-31.1c12.7-17 48.7-66.4 48.8-66.5zm-72.8 48.5a77.7 77.7 0 0 0-14.9 50.6c4 77-17 136.8-62.3 177.6-53 47.7-138.3 66.4-234.2 51.3a232.2 232.2 0 0 1-50.2-14.9 795.6 795.6 0 0 0 90.9-37.3l52.4-24.8-57.8-3.7a81.8 81.8 0 0 1-65-37c7.5-.5 14.8-1.7 22-3.7l55.2-15.4-55.7-13.6a82.9 82.9 0 0 1-61.5-59.4c5.5 1.5 12 2.6 22.5 3.6l51.5 5.1-40.8-31.8C62 128 50.1 93.7 58.8 60.6c91.7 95.1 199.5 88 210.3 90.5-2.4-23.2-2.4-23.2-3-25.4a68.9 68.9 0 0 1 30.2-82.5C325 25.6 370.5 22.9 402 52c6.8 6.2 16 8.7 24.6 6.5 7.8-1.9 14.1-4 20.3-6.1l-12.9 37h16.5l-11.3 15.1zm0 0"
})));

/* harmony default export */ __webpack_exports__["Z"] = (SvgTwitter);

/***/ }),

/***/ 2409:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Card; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const Card = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(/*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((param, ref)=>{
    let { children , as: As = "article" , className , ...props } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(As, {
        ...props,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- it's alright
        ref: ref,
        className: `mb-2 pb-12 bg-gray-100 rounded-lg ${className ?? ""}`,
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: "intersection-observer--pixel-to-watch"
            })
        ]
    });
}));
Card.displayName = "Card";


/***/ }),

/***/ 8683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ LinkUnderlineEffect; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


const LinkUnderlineEffect = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)(/*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((param, fref)=>{
    let { children , href  } = param;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- necessary to cast
    const link = react__WEBPACK_IMPORTED_MODULE_1__.Children.only(children);
    const className = link.props.className ?? "";
    const newProps = {
        ...link.props,
        href: href || link.props.href,
        ref: fref,
        className: `${className} fancy-link`
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "fancy-inner-link",
        children: /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.cloneElement)(link, newProps)
    });
}));
LinkUnderlineEffect.displayName = "LinkUnderlineEffect";


/***/ }),

/***/ 4453:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ Widget; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _Card__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2409);



const Widget = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.memo)((param)=>{
    let { children , title  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Card__WEBPACK_IMPORTED_MODULE_2__/* .Card */ .Z, {
        as: "section",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "-mb-8 pt-5 px-8",
            children: [
                title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "mb-3 text-gray-800 text-lg font-semibold",
                    children: title
                }),
                children
            ]
        })
    });
});
Widget.displayName = "Widget";


/***/ }),

/***/ 4082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ SiteHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./hooks/runningHeader.tsx + 1 modules
var runningHeader = __webpack_require__(536);
;// CONCATENATED MODULE: ./images/logo-typeofweb-black.svg
var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgLogoTypeofwebBlack = props => /*#__PURE__*/react.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 631 106"
}, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
  fill: "none"
}, /*#__PURE__*/react.createElement("path", {
  fill: "#161326",
  d: "M0 12.7 16.5 10v17.2h19.8v13.7H16.5v20.5c0 3.5.6 6.3 1.8 8.3 1.2 2.1 3.7 3.2 7.4 3.2 3.6 0 7.2-.7 10.6-2l2.3 13A38.6 38.6 0 0 1 11.8 85 17.5 17.5 0 0 1 1.1 71.9C.3 68.6 0 65 0 61.7v-49zm102.6 14.5A510.1 510.1 0 0 1 92 58.8c-3.5 9.7-7.5 19.2-11.8 28.6-1.4 3-3 5.7-4.7 8.5a26.2 26.2 0 0 1-5 5.7 18 18 0 0 1-6.4 3.3 33.3 33.3 0 0 1-20.7-1.3l3-13.1a28.2 28.2 0 0 0 8.7 1.5c3 0 5.2-.8 6.8-2.4a19 19 0 0 0 4-6.6A330.7 330.7 0 0 1 44 27.2h17.5l2.6 9.3A443 443 0 0 0 74 65.6a245.3 245.3 0 0 0 6-18.9l5.4-19.5h17zm46 29.6a20 20 0 0 0-3.4-12.3c-2.3-3-5.7-4.6-10.2-4.6a46 46 0 0 0-7.2.6v29.8c1.2.8 2.6 1.3 4 1.7 1.7.4 3.4.6 5 .6 7.9 0 11.8-5.3 11.8-15.8zm16.8-.5a43 43 0 0 1-1.7 12.3c-1 3.5-2.6 6.7-4.8 9.6a22 22 0 0 1-8 6.2 29.4 29.4 0 0 1-23.1-.3V106h-16.5V29.2a65 65 0 0 1 11.1-2.4 115.8 115.8 0 0 1 12.7-1c4.8 0 9 .8 12.8 2.2a25.8 25.8 0 0 1 15.5 15.7c1.3 3.8 2 8 2 12.6zm48.7-5.8c-.1-1.4-.3-2.8-.7-4.1-.4-1.3-1-2.5-2-3.6-.8-1-2-2-3.1-2.5-1.5-.8-3.2-1-4.9-1a9.8 9.8 0 0 0-8 3.4 8 8 0 0 0-2 3.6c-.5 1.3-.9 2.7-1.1 4.2H214zm-38.7 6.3c0-5.2.7-9.7 2.3-13.6a29 29 0 0 1 6.3-9.7 27.8 27.8 0 0 1 19.3-7.9c8.2 0 14.7 2.6 19.5 7.6 4.8 5 7.2 12.5 7.2 22.4l-.1 3.1-.2 3h-37.4A11 11 0 0 0 197 70c2.8 2 6.6 3 11.3 3a47.7 47.7 0 0 0 16-3l2.3 13.5a45.5 45.5 0 0 1-14.3 3.3c-2 .2-4.1.3-6.2.3-5.2 0-9.8-.7-13.7-2.3a25.3 25.3 0 0 1-15.3-16 38 38 0 0 1-1.8-12z"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#5AB783",
  d: "M269.2 83.5 241 61.3v-5.5l28.2-22 2.5 6.6-22.4 18.2 22.4 18.1-2.5 6.8zM326 56.9c0-6.5-1.5-11.6-4.4-15.4a14.1 14.1 0 0 0-11.8-5.7c-5 0-9 2-11.8 5.7-3 3.8-4.4 9-4.4 15.4 0 6.5 1.5 11.6 4.4 15.4a14 14 0 0 0 11.8 5.7c5 0 9-2 11.8-5.7 3-3.8 4.4-9 4.4-15.4zm10.7 0c0 4.2-.7 8.4-2 12.3a28.2 28.2 0 0 1-5.6 9.5 24.5 24.5 0 0 1-8.5 6.1 27.4 27.4 0 0 1-21.6.1 24.4 24.4 0 0 1-8.5-6.2 28.3 28.3 0 0 1-5.6-9.5 39.6 39.6 0 0 1 0-24.6 28 28 0 0 1 5.6-9.5 24.9 24.9 0 0 1 19.3-8.3c3.9 0 7.5.7 10.8 2.1a27.2 27.2 0 0 1 14.1 15.7c1.3 4 2 8.1 2 12.3zm31-56.9A39.2 39.2 0 0 1 380 1.9l-1.9 8.8c-1.2-.6-2.4-1-3.7-1.3-1.6-.4-3.6-.6-6-.6-4.7 0-8 1.3-10 4a17.5 17.5 0 0 0-2.8 10.5v5h22v8.5h-22v48.8h-10.3V23c0-7.4 1.8-13 5.4-17 3.6-4 9.3-6 17-6zM418 61.4l-28.2 22-2.5-6.5 22.4-18.3-11.2-9c-3.7-3.2-7.4-6.2-11.2-9.2l2.5-6.7L418 55.8v5.6z"
}), /*#__PURE__*/react.createElement("path", {
  fill: "#161326",
  d: "M465 52.2a499.7 499.7 0 0 1-9.9 33.3h-12.8a483 483 0 0 1-14.2-41c-1.8-5.6-3.5-11.3-5.1-17h17.4a1785 1785 0 0 0 6.6 28.3 316 316 0 0 0 2.6 9.6 445.1 445.1 0 0 0 5.5-19.9l2.4-9.4 2-8.6h12l2 8.6 2.3 9.4a702.1 702.1 0 0 0 5.3 20 433 433 0 0 0 7.4-29.3l2-8.7h17a875.7 875.7 0 0 1-15 47 216 216 0 0 1-4.3 11h-12.8l-5.5-16.7a329 329 0 0 1-4.8-16.6zm86-1.5c-.1-1.4-.4-2.8-.8-4.1a10 10 0 0 0-5-6 9.4 9.4 0 0 0-4.9-1 9.8 9.8 0 0 0-10.1 7 18 18 0 0 0-1 4h21.7zm-38.8 6.2c0-5.1.8-9.6 2.4-13.5a29 29 0 0 1 6.3-9.6A28 28 0 0 1 540 26c8.3 0 14.8 2.5 19.6 7.5 4.8 5 7.2 12.5 7.2 22.2l-.1 3.2-.3 3h-37.3c.3 3.2 2 6.2 4.7 8 2.8 2 6.6 3 11.3 3a48 48 0 0 0 16-2.9l2.2 13.4a45.7 45.7 0 0 1-14.3 3.3c-2 .2-4 .3-6.1.3-5.3 0-9.8-.8-13.7-2.3A25 25 0 0 1 514 68.8a37.6 37.6 0 0 1-1.8-11.9zm102-.8c0-10.6-4-16-11.7-16a19.3 19.3 0 0 0-9.1 2.4v29.9a33.2 33.2 0 0 0 7.2.5c4.5 0 7.9-1.5 10.2-4.6a20 20 0 0 0 3.4-12.2zm16.8.4c0 4.6-.7 8.8-2 12.5a26 26 0 0 1-15.4 15.7 36 36 0 0 1-12.9 2.2 74.8 74.8 0 0 1-12.7-1 83 83 0 0 1-11-2.3v-81L593.3 0v28.9a29.5 29.5 0 0 1 23.1-.4c3.2 1.4 5.8 3.4 8 6 2.2 2.9 3.9 6.1 4.8 9.6 1.2 4 1.7 8.2 1.7 12.4z"
}))));

/* harmony default export */ var logo_typeofweb_black = (SvgLogoTypeofwebBlack);
;// CONCATENATED MODULE: ./utils/pageKind.ts
const isIndex = (pageKind)=>{
    switch(pageKind){
        case "index":
        case "series":
        case "category":
            return true;
        default:
            return false;
    }
};

// EXTERNAL MODULE: ./components/atoms/LinkUnderlineEffect.tsx
var LinkUnderlineEffect = __webpack_require__(8683);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./hooks/useUiState.tsx
var useUiState = __webpack_require__(8654);
// EXTERNAL MODULE: ./images/react-icon.svg
var react_icon = __webpack_require__(5759);
// EXTERNAL MODULE: ./images/social/js.svg
var js = __webpack_require__(493);
// EXTERNAL MODULE: ./images/social/ts.svg
var ts = __webpack_require__(5452);
// EXTERNAL MODULE: ./utils/categories.ts
var categories = __webpack_require__(731);
// EXTERNAL MODULE: ./utils/permalinks.ts
var permalinks = __webpack_require__(4807);
;// CONCATENATED MODULE: ./components/molecules/MainNav.tsx










const iconClasses = "mr-1.5 w-6 h-6 lg:hidden xl:inline";
const iconForItem = {
    "react-js" () {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react_icon/* default */.Z, {
            className: `${iconClasses} fill-current text-[color:#61DAFB] transform-gpu rotate-0 group-hover:rotate-180 transition-transform`
        });
    },
    typescript () {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ts/* default */.Z, {
            className: `${iconClasses} text-[color:#007acc]`
        });
    },
    javascript () {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(js/* default */.Z, {
            className: `${iconClasses} w-7 h-7 bg-[color:#f0db4f] text-white`
        });
    }
};
const navItems = [
    ...categories/* allCategories.map */.Lp.map((c)=>({
            slug: c.slug,
            label: c.name
        })),
    {
        slug: "react-js",
        label: "Kurs React"
    },
    {
        slug: "wspolpraca",
        label: "O mnie i wsp\xf3łpraca",
        className: "lg:hidden"
    }
];
const MainNav = /*#__PURE__*/ (0,react.memo)(()=>{
    const { uiState , setUIState  } = (0,useUiState/* useUIState */.J)();
    const router = (0,next_router.useRouter)();
    const permalink = router.query["permalink"] || router.query["seriesSlug"];
    const closeMenu = (0,react.useCallback)(()=>{
        setUIState((state)=>({
                ...state,
                isMenuOpen: false
            }));
    }, [
        setUIState
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
        id: "main-menu",
        role: "navigation",
        className: `${uiState.isMenuOpen ? "translate-x-0" : "translate-x-full"} left-0 top-0 bottom-0 z-40 lg:transform-none lg:flex lg:bg-transparent lg:static lg:w-auto lg:h-auto fixed w-full min-h-full transition-transform bg-gray-100 flex lg:flex-1 items-center lg:items-stretch`,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "overflow-y-auto w-full h-full max-h-screen lg:pb-0 lg:pt-0",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "flex lg:flex-1 flex-col gap-8 items-center justify-center lg:h-full text-3xl lg:flex-row lg:gap-0 lg:items-stretch lg:justify-around lg:text-base pt-16 pb-24 lg:py-0",
                children: navItems.map((item)=>{
                    const isActive = permalink === item.slug;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: `flex items-stretch mt-0.5 ${item.className ?? ""}`,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: (0,permalinks/* getUrlForPermalink */.U)(item.slug),
                            scroll: true,
                            legacyBehavior: true,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                onClick: closeMenu,
                                className: `group inline-flex items-center border-b-2 transition-colors text-3xl lg:text-base whitespace-nowrap ${isActive ? "text-green-500 font-semibold  border-green-500 hover:border-green-700 hover:text-green-700" : "text-gray-800 hover:text-green-500 border-transparent hover:border-green-500"}`,
                                "aria-current": isActive,
                                children: [
                                    iconForItem[item.slug]?.(),
                                    item.label
                                ]
                            })
                        })
                    }, item.slug);
                })
            })
        })
    });
});
MainNav.displayName = "MainNav";

;// CONCATENATED MODULE: ./components/molecules/SiteHeader.tsx








const SiteHeader = /*#__PURE__*/ (0,react.memo)((param)=>{
    let { pageKind  } = param;
    const { text , progress  } = (0,runningHeader/* useRunningHeader */.i)();
    const HeaderEl = isIndex(pageKind) ? "h1" : "div";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                href: "#main-content",
                className: "focus:not-sr-only sr-only",
                children: "Skocz do treści"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                className: "ios:transcluent-white after:absolute fixed z-50 after:bottom-0 top-0 flex flex-row items-stretch justify-center pb-1 after:w-full w-full after:h-1 h-12 bg-gray-100 after:bg-gray-200 shadow overflow-hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        itemScope: true,
                        itemType: "http://schema.org/WPHeader",
                        className: "flex flex-1 flex-row px-4 max-w-3xl xl:px-0",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(HeaderEl, {
                                    itemProp: "headline",
                                    className: "-ml-2 p-2",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "sr-only",
                                            children: "Type of Web"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(logo_typeofweb_black, {
                                            className: "mt-0.5 w-36 max-w-full"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MainNav, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden lg:flex lg:items-center lg:mx-4 lg:px-8 lg:w-80",
                        "aria-hidden": true,
                        children: pageKind === "post" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            "aria-live": "off",
                            className: "animate-delay-1000 text-gray-600 font-serif text-xs animate-appear lg:whitespace-nowrap lg:text-sm",
                            children: text
                        })
                    }),
                    pageKind === "post" && /*#__PURE__*/ (0,jsx_runtime.jsx)("progress", {
                        "aria-hidden": true,
                        className: "absolute z-10 bottom-0 w-full h-1 text-pink-500 appearance-none",
                        value: progress.toFixed(2)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "fixed z-10 top-12 text-lg flex items-center justify-center px-6 py-1 w-full text-center bg-white shadow-md border-2 font-serif",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkUnderlineEffect/* LinkUnderlineEffect */.t, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            className: "text-blue-500 font-bold",
                            href: "https://www.next13masters.pl/?utm_source=typeofweb&utm_medium=sidebar",
                            children: "Już wkr\xf3tce odpalamy zapisy na drugą edycję next13masters.pl. Zapisz się na listę oczekujących!"
                        })
                    })
                })
            })
        ]
    });
});
SiteHeader.displayName = "SiteHeader";


/***/ }),

/***/ 8467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "tZ": function() { return /* binding */ SocialWidget; },
  "Av": function() { return /* binding */ myUrls; },
  "xs": function() { return /* binding */ social; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./images/social/click.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgClick = props => /*#__PURE__*/react.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  viewBox: "2 2 22 22"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-5l-5 5v-5z"
})));

/* harmony default export */ var click = (SvgClick);
// EXTERNAL MODULE: ./images/social/facebook.svg
var facebook = __webpack_require__(3869);
;// CONCATENATED MODULE: ./images/social/github.svg
var github_path;

function github_extends() { github_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return github_extends.apply(this, arguments); }



const SvgGithub = props => /*#__PURE__*/react.createElement("svg", github_extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), github_path || (github_path = /*#__PURE__*/react.createElement("path", {
  d: "M256 0C115.3 0 0 116.3 0 257c0 139.9 114.3 255 256 255 141.6 0 256-115 256-255C512 116.3 396.7 0 256 0zm45 477.5a222.3 222.3 0 0 1-90 0v-70.2c0-16.8 4.5-22.8 10.5-30.9 3-3.5 4.9-6.6 18.6-27.3l-23.1-3.6c-59.4-8.7-82.8-39.6-92.1-63.6a102 102 0 0 1 15.9-97.8 18 18 0 0 0 3.6-17.4 88.4 88.4 0 0 1-.9-44.1c16 2.3 32.3 13.7 45.9 21.9 6.3 3.7 9.6 2.7 12.6 3 11-2.3 28-7.8 54.3-7.8 16.2 0 33.3 2.4 50.1 7.2 3 0 7.8 2.5 16.2-2.4 14.3-8.7 30-19.7 45.9-21.9 3 8.4 3.6 30.3-.9 44.1a18 18 0 0 0 3.6 17.4 102 102 0 0 1 15.9 97.8c-9.3 24-32.7 54.9-92.1 63.6l-23.1 3.6c14.2 21.4 15.7 24 18.6 27.3 6 8.1 10.5 14.1 10.5 30.9zm30-8.7v-61.5a72 72 0 0 0-8.4-36.9c45.6-12.3 78-39.3 92.4-78a131.9 131.9 0 0 0-17.1-123c4.5-20.1 4.5-52.2-6.3-67.2A23.4 23.4 0 0 0 371.8 92h-.3c-23.3 1.3-41.6 13-61.2 24.9a207.2 207.2 0 0 0-108.3 0c-20.7-12.5-38.8-23.7-62.7-24.9a23 23 0 0 0-18.9 10.2c-10.8 15-10.8 47.1-6.3 67.2a132 132 0 0 0-17.1 123c14.4 38.7 46.8 65.7 92.4 78a65 65 0 0 0-7.8 26.3 40 40 0 0 1-24.7 2 33 33 0 0 1-19.2-16.5c-12-20-32.2-36.3-55.3-34.2l2.6 30c10.7-1 21.4 10.3 26.9 19.7a63 63 0 0 0 36.5 29.9 63.5 63.5 0 0 0 32.6.9v40.4A225.5 225.5 0 0 1 30 257C30 132.8 131.8 30 256 30s226 102.8 226 227c0 97.8-63.7 181.2-151 211.8zm0 0"
})));

/* harmony default export */ var github = (SvgGithub);
;// CONCATENATED MODULE: ./images/social/instagram.svg
var instagram_path, _path2;

function instagram_extends() { instagram_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return instagram_extends.apply(this, arguments); }



const SvgInstagram = props => /*#__PURE__*/react.createElement("svg", instagram_extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), instagram_path || (instagram_path = /*#__PURE__*/react.createElement("path", {
  d: "M75 512h362a75 75 0 0 0 75-75V75a75 75 0 0 0-75-75H75A75 75 0 0 0 0 75v362a75 75 0 0 0 75 75zM30 75a45 45 0 0 1 45-45h362a45 45 0 0 1 45 45v362a45 45 0 0 1-45 45H75a45 45 0 0 1-45-45zm0 0"
})), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
  d: "M256 391c74.4 0 135-60.6 135-135s-60.6-135-135-135-135 60.6-135 135 60.6 135 135 135zm0-240a105.1 105.1 0 0 1 0 210 105.1 105.1 0 0 1 0-210zm150 0a45 45 0 1 0-.1-90.1 45 45 0 0 0 .1 90.1zm0-60a15 15 0 1 1 0 30 15 15 0 0 1 0-30zm0 0"
})));

/* harmony default export */ var instagram = (SvgInstagram);
;// CONCATENATED MODULE: ./images/social/jsonfeed.svg
var _g;

function jsonfeed_extends() { jsonfeed_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return jsonfeed_extends.apply(this, arguments); }



const SvgJsonfeed = props => /*#__PURE__*/react.createElement("svg", jsonfeed_extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 106 106"
}, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 5
}, /*#__PURE__*/react.createElement("path", {
  d: "m33.9 81.7.1.1c5.9-5.8 10.1-5.4 17.1 1.7l11.2 11.1c11.6 11.6 22.4 11 35.3-2l4-3.9-8.4-8.4-2 2c-7.4 7.4-12.5 7.5-19.5.4l-13-13c-6.8-6.7-13.5-7.4-19.9-2l-1.3-1.3c5.5-6.7 5-12.9-1.5-19.4L24.3 35.3c-7.2-7.1-7.1-12.1.3-19.5l2-2-8.4-8.4-3.9 4c-13 13-13.7 23.5-2.4 34.8l9.7 9.7c7 7 7.5 11.3 1.7 17.1A7.6 7.6 0 0 0 34 81.8z"
}), /*#__PURE__*/react.createElement("g", {
  opacity: 0.5,
  transform: "rotate(-45 80 -34.8)"
}, /*#__PURE__*/react.createElement("circle", {
  cx: 7.5,
  cy: 7.5,
  r: 7.5
}), /*#__PURE__*/react.createElement("circle", {
  cx: 32.5,
  cy: 7.5,
  r: 7.5
}), /*#__PURE__*/react.createElement("circle", {
  cx: 57.5,
  cy: 7.5,
  r: 7.5
})))));

/* harmony default export */ var jsonfeed = (SvgJsonfeed);
;// CONCATENATED MODULE: ./images/social/link.svg
var link_path;

function link_extends() { link_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return link_extends.apply(this, arguments); }



const SvgLink = props => /*#__PURE__*/react.createElement("svg", link_extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, props), link_path || (link_path = /*#__PURE__*/react.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M10 6H6a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2v-4M14 4h6m0 0v6m0-6L10 14"
})));

/* harmony default export */ var social_link = (SvgLink);
// EXTERNAL MODULE: ./images/social/linkedin.svg
var linkedin = __webpack_require__(6505);
;// CONCATENATED MODULE: ./images/social/rss.svg
var rss_path, rss_path2, _path3;

function rss_extends() { rss_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return rss_extends.apply(this, arguments); }



const SvgRss = props => /*#__PURE__*/react.createElement("svg", rss_extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), rss_path || (rss_path = /*#__PURE__*/react.createElement("path", {
  d: "M15 120c207.9 0 377 169.1 377 377v15h120v-15a495.2 495.2 0 0 0-146-351A495.2 495.2 0 0 0 15 0H0v120zm15-89.8A467.6 467.6 0 0 1 481.8 482h-60a406.8 406.8 0 0 0-119.4-272.4A405.8 405.8 0 0 0 30 90.3zm0 0"
})), rss_path2 || (rss_path2 = /*#__PURE__*/react.createElement("path", {
  d: "M212 497v15h120v-15a316 316 0 0 0-93.3-223.7A316 316 0 0 0 15 180H0v120h15c106.8 0 197 90.2 197 197zM30 210.4A287.4 287.4 0 0 1 301.6 482h-60.1a225.5 225.5 0 0 0-66.4-145.1A225.5 225.5 0 0 0 30 270.5zm0 0"
})), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
  d: "M76 512c41.3 0 76-34.4 76-76 0-41.3-34.4-76-76-76-41.3 0-76 34.4-76 76 0 41.3 34.4 76 76 76zm0-122c25 0 46 21 46 46s-21 46-46 46-46-21-46-46 21-46 46-46zm0 0"
})));

/* harmony default export */ var rss = (SvgRss);
// EXTERNAL MODULE: ./images/social/twitter.svg
var twitter = __webpack_require__(1071);
;// CONCATENATED MODULE: ./images/social/youtube.svg
var youtube_path, youtube_path2;

function youtube_extends() { youtube_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return youtube_extends.apply(this, arguments); }



const SvgYoutube = props => /*#__PURE__*/react.createElement("svg", youtube_extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 -61 512 512"
}, props), youtube_path || (youtube_path = /*#__PURE__*/react.createElement("path", {
  d: "M75 390h362a75 75 0 0 0 75-75V75a75 75 0 0 0-75-75H75A75 75 0 0 0 0 75v240a75 75 0 0 0 75 75zM30 75a45 45 0 0 1 45-45h362a45 45 0 0 1 45 45v240a45 45 0 0 1-45 45H75a45 45 0 0 1-45-45zm0 0"
})), youtube_path2 || (youtube_path2 = /*#__PURE__*/react.createElement("path", {
  d: "M181 94.5v204l180.5-103.7zm30 51 89.5 49.7-89.5 51.4zm0 0"
})));

/* harmony default export */ var youtube = (SvgYoutube);
// EXTERNAL MODULE: ./components/atoms/Widget.tsx
var Widget = __webpack_require__(4453);
;// CONCATENATED MODULE: ./components/molecules/SocialWidget.tsx














const social = [
    {
        icon: facebook/* default */.Z,
        label: "Facebook",
        slug: "facebook",
        className: "text-[#4267B2]"
    },
    {
        icon: youtube,
        label: "YouTube",
        slug: "youtube",
        className: "text-[#FF0000]"
    },
    {
        icon: github,
        label: "GitHub",
        slug: "github",
        className: "text-[#24292e]"
    },
    {
        icon: instagram,
        label: "Instagram",
        slug: "instagram",
        className: "text-[#bc2a8d]"
    },
    {
        icon: twitter/* default */.Z,
        label: "Twitter",
        slug: "twitter",
        className: "text-[#1DA1F2]"
    },
    {
        icon: linkedin/* default */.Z,
        label: "LinkedIn",
        slug: "linkedin",
        className: "text-[#0077b5]"
    },
    {
        icon: social_link,
        label: "Strona WWW",
        slug: "website",
        className: "hidden"
    }
];
const myUrls = {
    twitter: "https://twitter.com/typeofweb",
    facebook: "https://facebook.com/typeofweb",
    github: "https://github.com/typeofweb",
    youtube: "https://www.youtube.com/c/typeofweb",
    instagram: "https://instagram.com/michal_typeofweb",
    linkedin: "https://linkedin.com/in/mmiszczyszyn",
    website: "https://typeofweb.com"
};
const SocialWidget = /*#__PURE__*/ (0,react.memo)(()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Widget/* Widget */.$, {
        title: "Śledź mnie na:",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "flex flex-row gap-3 justify-between",
                children: social.map((param)=>{
                    let { icon: Icon , label , slug , className  } = param;
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: `${className ? className : "text-gray-700"} hover:text-green-700 transition-colors`,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: myUrls[slug],
                            "aria-label": label,
                            title: label,
                            className: "block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                className: "w-8 fill-current"
                            })
                        })
                    }, label);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                className: "flex flex-row flex-wrap gap-3 justify-between",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "mt-7 text-gray-700 hover:text-green-700 text-lg font-semibold transition-colors",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                            href: "/feed.json",
                            "aria-label": "JSON Feed",
                            title: "JSON Feed",
                            className: "block",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(jsonfeed, {
                                    className: "inline-block mr-2 w-8 fill-current"
                                }),
                                "JSON Feed"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                        className: "mt-7 text-gray-700 hover:text-green-700 text-lg font-semibold transition-colors",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                            href: "/feed.xml",
                            "aria-label": "RSS",
                            title: "RSS",
                            className: "block",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(rss, {
                                    className: "inline-block mr-2 w-8 fill-current"
                                }),
                                "RSS"
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                className: "flex flex-row flex-wrap gap-3 justify-between",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: "ml-0 mt-7 pl-0 text-gray-700 hover:text-green-700 text-lg font-semibold transition-colors",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                        href: "/wspolpraca",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(click, {
                                className: "inline-block mr-2 w-8 stroke-current"
                            }),
                            "O mnie i wsp\xf3łpraca"
                        ]
                    })
                })
            })
        ]
    });
});
SocialWidget.displayName = "SocialWidget";


/***/ }),

/***/ 8578:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ AppFooter; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./images/react-icon.svg
var react_icon = __webpack_require__(5759);
;// CONCATENATED MODULE: ./images/social/badge-check.svg
var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



const SvgBadgeCheck = props => /*#__PURE__*/react.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  className: "h-6 w-6",
  viewBox: "2.07 2.07 19.85 19.85"
}, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m9 12 2 2 4-4M7.835 4.697a3.42 3.42 0 0 0 1.946-.806 3.42 3.42 0 0 1 4.438 0 3.42 3.42 0 0 0 1.946.806 3.42 3.42 0 0 1 3.138 3.138 3.42 3.42 0 0 0 .806 1.946 3.42 3.42 0 0 1 0 4.438 3.42 3.42 0 0 0-.806 1.946 3.42 3.42 0 0 1-3.138 3.138 3.42 3.42 0 0 0-1.946.806 3.42 3.42 0 0 1-4.438 0 3.42 3.42 0 0 0-1.946-.806 3.42 3.42 0 0 1-3.138-3.138 3.42 3.42 0 0 0-.806-1.946 3.42 3.42 0 0 1 0-4.438 3.42 3.42 0 0 0 .806-1.946 3.42 3.42 0 0 1 3.138-3.138z"
})));

/* harmony default export */ var badge_check = (SvgBadgeCheck);
;// CONCATENATED MODULE: ./images/social/briefcase.svg
var briefcase_path;

function briefcase_extends() { briefcase_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return briefcase_extends.apply(this, arguments); }



const SvgBriefcase = props => /*#__PURE__*/react.createElement("svg", briefcase_extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  className: "h-6 w-6",
  viewBox: "2 1 20 20"
}, props), briefcase_path || (briefcase_path = /*#__PURE__*/react.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M21 13.255A23.931 23.931 0 0 1 12 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2m4 6h.01M5 20h14a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2z"
})));

/* harmony default export */ var briefcase = (SvgBriefcase);
;// CONCATENATED MODULE: ./images/social/chat-alt.svg
var chat_alt_path;

function chat_alt_extends() { chat_alt_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return chat_alt_extends.apply(this, arguments); }



const SvgChatAlt = props => /*#__PURE__*/react.createElement("svg", chat_alt_extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  className: "h-6 w-6",
  viewBox: "2.5 3.5 19 19"
}, props), chat_alt_path || (chat_alt_path = /*#__PURE__*/react.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M17 8h2a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-2v4l-4-4H9a1.994 1.994 0 0 1-1.414-.586m0 0L11 14h4a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2v4l.586-.586z"
})));

/* harmony default export */ var chat_alt = (SvgChatAlt);
;// CONCATENATED MODULE: ./images/social/computer.svg
var computer_path;

function computer_extends() { computer_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return computer_extends.apply(this, arguments); }



const SvgComputer = props => /*#__PURE__*/react.createElement("svg", computer_extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  viewBox: "2.5 2.5 19 19"
}, props), computer_path || (computer_path = /*#__PURE__*/react.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M9.75 17 9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2z"
})));

/* harmony default export */ var computer = (SvgComputer);
;// CONCATENATED MODULE: ./images/social/cube-transparent.svg
var cube_transparent_path;

function cube_transparent_extends() { cube_transparent_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return cube_transparent_extends.apply(this, arguments); }



const SvgCubeTransparent = props => /*#__PURE__*/react.createElement("svg", cube_transparent_extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  className: "h-6 w-6",
  viewBox: "3 2 18 20"
}, props), cube_transparent_path || (cube_transparent_path = /*#__PURE__*/react.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "m14 10-2 1m0 0-2-1m2 1v2.5M20 7l-2 1m2-1-2-1m2 1v2.5M14 4l-2-1-2 1M4 7l2-1M4 7l2 1M4 7v2.5M12 21l-2-1m2 1 2-1m-2 1v-2.5M6 18l-2-1v-2.5M18 18l2-1v-2.5"
})));

/* harmony default export */ var cube_transparent = (SvgCubeTransparent);
// EXTERNAL MODULE: ./images/social/discord.svg
var discord = __webpack_require__(6771);
;// CONCATENATED MODULE: ./images/social/globe.svg
var globe_path;

function globe_extends() { globe_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return globe_extends.apply(this, arguments); }



const SvgGlobe = props => /*#__PURE__*/react.createElement("svg", globe_extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  className: "h-6 w-6",
  viewBox: "2.5 2.5 19 19"
}, props), globe_path || (globe_path = /*#__PURE__*/react.createElement("path", {
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M3.055 11H5a2 2 0 0 1 2 2v1a2 2 0 0 0 2 2 2 2 0 0 1 2 2v2.945M8 3.935V5.5A2.5 2.5 0 0 0 10.5 8h.5a2 2 0 0 1 2 2 2 2 0 1 0 4 0 2 2 0 0 1 2-2h1.064M15 20.488V18a2 2 0 0 1 2-2h3.064M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0z"
})));

/* harmony default export */ var globe = (SvgGlobe);
// EXTERNAL MODULE: ./images/social/js.svg
var js = __webpack_require__(493);
// EXTERNAL MODULE: ./images/social/ts.svg
var ts = __webpack_require__(5452);
;// CONCATENATED MODULE: ./public/powered-by-vercel.svg
var powered_by_vercel_path, _path2, _path3, _path4;

function powered_by_vercel_extends() { powered_by_vercel_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return powered_by_vercel_extends.apply(this, arguments); }



const SvgPoweredByVercel = props => /*#__PURE__*/react.createElement("svg", powered_by_vercel_extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 209 40"
}, props), powered_by_vercel_path || (powered_by_vercel_path = /*#__PURE__*/react.createElement("path", {
  fill: "#000",
  d: "M0 5a5 5 0 0 1 5-5h199a5 5 0 0 1 5 5v30a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5V5z"
})), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m20 13 8 14H12l8-14z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
  stroke: "#333",
  d: "M40.5 0v40"
})), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
  fill: "#fff",
  d: "M53.3 26H55v-4h2.4c2.7 0 4-1.7 4-3.9 0-2.1-1.3-3.7-4-3.7h-4.1V26zm1.7-5.6V16h2.2c1.8 0 2.5 1 2.5 2.2 0 1.3-.7 2.3-2.4 2.3H55zm12 5.8c2.4 0 4-1.8 4-4.5s-1.6-4.5-4-4.5c-2.5 0-4.1 1.8-4.1 4.5s1.6 4.5 4 4.5zm0-1.4c-1.7 0-2.4-1.5-2.4-3.1 0-1.7.7-3.1 2.3-3.1 1.6 0 2.4 1.4 2.4 3 0 1.7-.8 3.1-2.4 3.1zm7.5 1.2h1.8l1.7-6.3h.2l1.7 6.3h1.8l2.5-8.7h-1.7l-1.7 6.4h-.1L79 17.3h-1.8l-1.7 6.4-1.8-6.4H72l2.5 8.7zm14.8.2c2 0 3.3-1 3.7-2.4l-1.6-.3c-.3.9-1 1.3-2 1.3-1.5 0-2.5-1-2.5-2.7H93v-.6c0-3.1-1.9-4.3-3.9-4.3-2.4 0-4 1.8-4 4.5s1.6 4.5 4.1 4.5zM87 20.9c0-1.3 1-2.3 2.3-2.3 1.4 0 2.2 1 2.2 2.3H87zm8 5.1h1.8v-5.3c0-1.2.8-2 2-2l1 .1v-1.6a7 7 0 0 0-.8 0c-1 0-1.9.5-2.2 1.5v-1.4H95V26zm9.7.2c1.9 0 3.2-1 3.6-2.4l-1.6-.3c-.3.9-1 1.3-2 1.3-1.5 0-2.5-1-2.5-2.7h6.2v-.6c0-3.1-1.9-4.3-3.9-4.3-2.4 0-4 1.8-4 4.5s1.6 4.5 4.2 4.5zm-2.5-5.3c0-1.3 1-2.3 2.4-2.3 1.3 0 2.1 1 2.1 2.3h-4.5zm11.4 5.3c1.5 0 2.2-1 2.5-1.6h.1V26h1.7V14.4H116v4.3h-.1c-.3-.6-1-1.5-2.5-1.5-2.1 0-3.7 1.6-3.7 4.5 0 2.8 1.5 4.5 3.7 4.5zm.3-1.5c-1.5 0-2.3-1.3-2.3-3 0-1.8.8-3.1 2.3-3.1 1.5 0 2.3 1.2 2.3 3 0 1.9-.8 3.1-2.3 3.1zm10.8 1.3h1.6v-1.4h.2c.3.6 1 1.6 2.5 1.6 2.1 0 3.6-1.7 3.6-4.5 0-2.9-1.5-4.5-3.6-4.5-1.6 0-2.2 1-2.5 1.5h-.1v-4.3h-1.7V26zm1.6-4.4c0-1.8.8-3 2.3-3 1.6 0 2.3 1.3 2.3 3 0 1.8-.8 3.1-2.3 3.1-1.4 0-2.3-1.2-2.3-3zm9 7.6c1.4 0 2.3-.7 2.8-2l3.6-10h-1.8l-2.2 6.8h-.1l-2.2-6.7h-1.8l3.1 8.8-.2.6c-.4 1.1-1 1.2-2 1l-.3 1.4 1.1.1zm14.2-14.8h-2.7l4 11.6h3.2l4-11.6h-2.7l-2.9 8.8-2.9-8.8zm12.8 11.8c2.2 0 3.6-1 4-2.7l-2.3-.1c-.2.6-.8 1-1.6 1-1.2 0-2-.8-2-2.1h6v-.7c0-3-1.9-4.4-4.2-4.4-2.5 0-4.2 1.8-4.2 4.5s1.6 4.5 4.3 4.5zm-2-5.4a2 2 0 0 1 2-1.8c1 0 1.7.7 1.8 1.8h-3.7zm7.6 5.2h2.4v-5c0-1 .8-1.8 1.9-1.8l1 .2v-2.2h-.8c-1 0-1.7.5-2 1.6h-.1v-1.5h-2.4V26zm10 .2c2.4 0 3.9-1.4 4-3.4h-2.3c-.1 1-.7 1.5-1.6 1.5-1.1 0-1.8-1-1.8-2.7 0-1.6.7-2.6 1.8-2.6 1 0 1.5.6 1.6 1.5h2.3c-.1-2-1.6-3.3-4-3.3-2.6 0-4.2 1.8-4.2 4.5 0 2.6 1.6 4.5 4.3 4.5zm9.5 0c2.2 0 3.6-1 4-2.7l-2.3-.1c-.2.6-.8 1-1.6 1-1.3 0-2-.8-2-2.1h6v-.7c0-3-1.9-4.4-4.2-4.4-2.5 0-4.2 1.8-4.2 4.5s1.6 4.5 4.3 4.5zm-2-5.4a2 2 0 0 1 2-1.8c1 0 1.7.7 1.7 1.8h-3.6zm10-6.4H193V26h2.4V14.4z"
})));

/* harmony default export */ var powered_by_vercel = (SvgPoweredByVercel);
// EXTERNAL MODULE: ./utils/categories.ts
var categories = __webpack_require__(731);
// EXTERNAL MODULE: ./utils/permalinks.ts
var permalinks = __webpack_require__(4807);
// EXTERNAL MODULE: ./utils/series.ts
var series = __webpack_require__(2475);
// EXTERNAL MODULE: ./components/molecules/SocialWidget.tsx + 7 modules
var SocialWidget = __webpack_require__(8467);
;// CONCATENATED MODULE: ./components/organisms/AppFooter.tsx


















const categoryToIcon = {
    javascript: js/* default */.Z,
    typescript: ts/* default */.Z,
    opinie: cube_transparent,
    "dobry-kod": badge_check,
    "praca-zdalna": briefcase
};
const sections = [
    {
        title: "Social",
        items: SocialWidget/* social.map */.xs.map((s)=>({
                ...s,
                url: SocialWidget/* myUrls */.Av[s.slug],
                fill: s.slug !== "website"
            }))
    },
    {
        title: "Strony",
        items: [
            {
                slug: "polski-frontend-discord",
                label: "Serwer Discord",
                icon: discord/* default */.Z
            },
            {
                slug: "michal-miszczyszyn-uses",
                label: "Sprzęt, kt\xf3rego używam",
                icon: computer
            },
            {
                slug: "wspolpraca",
                label: "O mnie i wsp\xf3łpraca",
                icon: chat_alt
            },
            {
                slug: "znajdz-prace-zdalna-tymi-serwisami",
                label: "Gdzie szukać pracy zdalnej?",
                icon: globe
            }
        ].map((l)=>({
                ...l,
                url: (0,permalinks/* getUrlForPermalink */.U)(l.slug)
            }))
    },
    {
        title: "Kategorie",
        items: [
            ...categories/* allCategories.map */.Lp.map((c)=>({
                    slug: c.slug,
                    label: c.name,
                    url: (0,categories/* getCategoryLink */.Od)(c),
                    icon: categoryToIcon[c.slug]
                })),
            {
                slug: "react-js",
                label: "Kurs React.js",
                url: (0,series/* getSeriesLink */.CX)("react-js"),
                icon: react_icon/* default */.Z
            }
        ]
    }
];
const AppFooter = /*#__PURE__*/ (0,react.memo)(()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: "app-footer py-8 text-blue-100 bg-blue-900",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("nav", {
                className: "w-fit flex flex-col gap-8 self-center mx-auto pb-8 max-w-5xl sm:flex-row sm:gap-0 sm:justify-around sm:w-auto",
                children: sections.map((s)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "mb-4 text-gray-200 text-xl font-bold sm:mb-6",
                                children: s.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: "flex flex-col gap-2 sm:gap-4",
                                children: s.items.map((param)=>{
                                    let { icon: Icon , label , slug , url , fill  } = param;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        className: "inline-flex items-center h-11",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)((link_default()), {
                                            href: url,
                                            className: "inline-flex flex-row items-center hover:text-green-700 transition-colors",
                                            children: [
                                                Icon && /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                                    className: `mr-4 w-8 ${fill ? "fill-current" : "stroke-current"} `
                                                }),
                                                label
                                            ]
                                        })
                                    }, slug);
                                })
                            })
                        ]
                    }, s.title))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("address", {
                className: "text-center leading-7",
                children: [
                    "Type of Web - Michał Miszczyszyn",
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "not-italic",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/polityka-prywatnosci",
                                className: "hover:text-green-700 underline transition-colors",
                                children: "Polityka prywatności"
                            }),
                            " | ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/regulamin",
                                className: "hover:text-green-700 underline transition-colors",
                                children: "Regulamin"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "mt-3 font-mono not-italic",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/humans.txt",
                                className: "hover:text-green-700 underline transition-colors",
                                children: "humans.txt"
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/lawyers.txt",
                                className: "hover:text-green-700 underline transition-colors",
                                children: "lawyers.txt"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: "mt-3 text-lg not-italic font-bold",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "inline-block",
                                children: "Znalazłeś/aś błąd na stronie?"
                            }),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "inline-block",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "https://github.com/typeofweb/typeofweb.com/issues/new",
                                        className: "hover:text-green-700 underline transition-colors",
                                        children: "Otw\xf3rz issue na GitHubie"
                                    }),
                                    "!"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        "aria-hidden": true,
                        className: "mt-3 text-xs not-italic font-extralight",
                        children: ("preview_imgbot_2a5ab881de6358155867be4f3a0799de87d12323" || 0).split("_").map((w)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "inline-block",
                                children: [
                                    w,
                                    " "
                                ]
                            }, w))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "mt-3 text-lg not-italic font-bold",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: "https://vercel.com?utm_source=typeofweb&utm_campaign=oss",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: "inline-block mt-10",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(powered_by_vercel, {
                                className: "mx-auto",
                                width: 209,
                                height: 40
                            })
                        })
                    })
                ]
            })
        ]
    });
});
AppFooter.displayName = "AppFooter";


/***/ }),

/***/ 4807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ getUrlForPermalink; }
/* harmony export */ });
/* harmony import */ var _categories__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(731);
/* harmony import */ var _series__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2475);


const getUrlForPermalink = (permalink)=>{
    return (0,_categories__WEBPACK_IMPORTED_MODULE_0__/* .permalinkIsCategory */ .Ws)(permalink) ? (0,_categories__WEBPACK_IMPORTED_MODULE_0__/* .getCategoryLink */ .Od)(permalink) : (0,_series__WEBPACK_IMPORTED_MODULE_1__/* .permalinkIsSeries */ .P3)(permalink) ? (0,_series__WEBPACK_IMPORTED_MODULE_1__/* .getSeriesLink */ .CX)(permalink) : `/${permalink}`;
};


/***/ })

}]);